import { LEVELS } from '@helpers';

// Master toggle: set to false to disable ALL operator restrictions globally
export const OPERATOR_RESTRICTIONS_ENABLED = true;

// Category constants to prevent typos when checking restrictions
export const RESTRICTION_CATEGORIES = Object.freeze({
  WEB_TABS: 'webTabs',
  PHONE_TABS: 'phoneTabs',
  MACHINE_TABS: 'machineTabs',
  MACHINE_NOW_SUB_TABS: 'machineNowSubTabs',
  SEARCH_LEVELS: 'searchLevels',
  SETTINGS_ITEMS: 'settingsItems',
  NC_FILE_TABS: 'ncFileTabs',
  BATCH_TABS: 'batchTabs',
  PROFILE_ACTIONS: 'profileActions',
  LIVE_OVERVIEW_HIDDEN: 'liveOverviewHiddenBlocks',
  LIVE_OVERVIEW_READ_ONLY: 'liveOverviewReadOnlyBlocks',
});

export const OPERATOR_RESTRICTIONS = {
  // Web Header tabs (blacklist) - hide these from web navigation
  webTabs: ['Planboard', 'Wallboard', 'Search', 'GlobalAdd'],

  // Phone bottom tab bar (blacklist)
  phoneTabs: ['GlobalAdd', 'SearchScreen'],

  // Machine screen main tabs (blacklist)
  // Live is also blacklistet here but it is still rendered since it is a default page (only the tab bar row disappears since
  // there are no items to show. The ScrollView renders empty with zero children.)
  machineTabs: ['Live', 'Performance', 'Events', 'History', 'Timeline', 'Scheduled', 'Maintenance'],

  // Machine Now sub-screens - Batch & NC File sub-menu tabs (blacklist)
  machineNowSubTabs: ['Performance', 'Events'],

  // Search - restricted levels (blacklist)
  searchLevels: [
    LEVELS.ProductionOrders,
    LEVELS.Operations, // "Jobs"
    LEVELS.ProductionBatches, // "Batches"
    LEVELS.ImagesDocuments,
  ],

  // Search "All" - only search in these levels (whitelist for "All" tab)
  searchAllowedInAll: [LEVELS.Parts, LEVELS.NCFiles, LEVELS.Tools],

  // Settings menu items (blacklist)
  settingsItems: ['Users', 'Devices', 'Machines', 'Connector', 'API Keys', 'Imnoo', 'Power BI', 'Company'],

  // NC File detail tabs (blacklist) - must match LevelSubScreen values (capitalized)
  ncFileTabs: ['Times', 'Events', 'Performance'],

  // Batch detail tabs (blacklist)
  batchTabs: ['Events'],

  // Profile dropdown actions (blacklist)
  profileActions: ['Add Machine', 'Invite Colleague'],

  // Live overview blocks (blacklist) - 'hidden' = don't render, 'readOnly' = render without onPress
  liveOverviewHiddenBlocks: ['OeeTodayBlock'],
  liveOverviewReadOnlyBlocks: ['BatchBlock', 'MachineActivityBlock'],

  // Devices - if true, operators only see their own devices (filtered by lastUsedBy)
  devicesOwnOnly: true,

  // Web/Tablet: operator goes ONLY to OperatorPanel (initial route + redirect + loading gate)
  operatorOnlyOP: true,

  // Hide "Go To Main App" button/menu item in OperatorPanel settings
  hideGoToMainApp: true,
};

// Mapping from search result itemType to LEVELS (used for filtering "All" search results)
export const ITEM_TYPE_TO_LEVEL = {
  Part: LEVELS.Parts,
  NcFile: LEVELS.NCFiles,
  Tool: LEVELS.Tools,
  ImageDocument: LEVELS.ImagesDocuments,
  OtherDocument: LEVELS.ImagesDocuments,
  ProductionOperation: LEVELS.Operations,
  ProductionOrder: LEVELS.ProductionOrders,
  ProductionBatch: LEVELS.ProductionBatches,
};
